import { Component, inject, input, LOCALE_ID, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-governate',
  imports: [ReactiveFormsModule],
  templateUrl: './governate.html',
  styleUrl: './governate.scss',
})
export class Governate {
  private locale = inject(LOCALE_ID);
  pharmacyForm = input.required<FormGroup>();
  governorates = input.required<{ id: number; titleAr?: string; titleEn: string; profileImageFid?: string }[]>();
  onGetCities = output<{ governorateId: number }>();
  isArabic() {
    return this.locale.startsWith('ar');
  }
  isEnglish() {
    return this.locale.startsWith('en');
  }

  onChangeGovernorate() {
    const governorateId = this.pharmacyForm().get('pharmacyGovernorate')?.value;
    this.onGetCities.emit({ governorateId });
  }
}
